import NoMatch from "@containers/no-match";

import { RouteType } from "./types";

export const PublicRoutes: RouteType[] = [
  //SIGN UP

  // NOMATCH
  {
    id: "3",
    path: "*",
    element: <NoMatch />,
  },
];
